module.exports = __webpack_public_path__ + "static/media/watch-icon.f0e32e89.svg";